import React from 'react';

const Home = () => {
  return (
    <div className="space-y-20">
      {/* Hero Section */}
      <section className="text-center py-20 bg-gradient-to-r from-teal-50 to-white">
        <div className="max-w-6xl mx-auto px-2 sm:px-4">
          <h1 className="text-4xl font-bold text-teal-600 mb-6 tracking-tight whitespace-nowrap">
            High-Performance Teams, Built for Scale
           </h1>
           <p className="text-xl text-gray-600 mb-8">
              With deep operational integration, we build and manage high-performance teams that drive business success.
           </p>
           <button className="bg-teal-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-teal-700">
              Transform Your Team Today
           </button>
        </div>
    </section>

      {/* Why Us Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12">Why Choose InfAI?</h2>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="p-6 bg-gray-50 rounded-lg">
              <h3 className="text-xl font-semibold mb-4">Beyond Consulting</h3>
              <p className="text-gray-600">
                We're not traditional consultants who leave after providing advice. We integrate
                deeply with your team, becoming a permanent extension of your business.
              </p>
            </div>
            <div className="p-6 bg-gray-50 rounded-lg">
              <h3 className="text-xl font-semibold mb-4">Operate Forever Model</h3>
              <p className="text-gray-600">
                Unlike Build-Operate-Transfer models, we commit to long-term partnerships, growing
                and evolving with your business needs.
              </p>
            </div>
            <div className="p-6 bg-gray-50 rounded-lg">
              <h3 className="text-xl font-semibold mb-4">Cost-Effective Excellence</h3>
              <p className="text-gray-600">
                Get high-quality team extension at optimized costs, helping you unlock better
                profit margins while maintaining premium quality.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Overview */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12">Our Expertise</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <h3 className="text-xl font-semibold mb-4">IT & Engineering</h3>
              <ul className="space-y-2 text-gray-600">
                <li>Software Development</li>
                <li>Cloud & DevOps</li>
                <li>Quality Assurance</li>
                <li>Technical Support</li>
              </ul>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <h3 className="text-xl font-semibold mb-4">Digital Marketing</h3>
              <ul className="space-y-2 text-gray-600">
                <li>Performance Marketing</li>
                <li>Content Operations</li>
                <li>Social Media Management</li>
                <li>Analytics & Insights</li>
              </ul>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <h3 className="text-xl font-semibold mb-4">Business Operations</h3>
              <ul className="space-y-2 text-gray-600">
                <li>Customer Support</li>
                <li>Finance & Accounting</li>
                <li>HR & Recruitment</li>
                <li>Sales Operations</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
